(() => {
  const DRAWER_SELECTOR = 'x-drawer[data-lbdb-deferred-media]';

  function restoreDeferredSources(root) {
    root.querySelectorAll('[data-lbdb-deferred-srcset]').forEach((element) => {
      element.setAttribute('srcset', element.dataset.lbdbDeferredSrcset);
      element.removeAttribute('data-lbdb-deferred-srcset');
    });

    root.querySelectorAll('[data-lbdb-deferred-src]').forEach((element) => {
      element.setAttribute('src', element.dataset.lbdbDeferredSrc);
      element.removeAttribute('data-lbdb-deferred-src');
    });
  }

  function hydrateDrawer(drawer) {
    if (!drawer || drawer.dataset.lbdbMediaHydrated === 'true') return;

    const template = drawer.querySelector('template[data-lbdb-deferred-drawer-template]');
    if (template) {
      template.replaceWith(template.content.cloneNode(true));
    }

    restoreDeferredSources(drawer);
    drawer.querySelectorAll('video').forEach((video) => video.load());
    drawer.dataset.lbdbMediaHydrated = 'true';
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest?.('[aria-controls]');
    if (!control) return;

    const controlledId = control.getAttribute('aria-controls');
    if (!controlledId) return;

    const drawer = document.getElementById(controlledId);
    if (drawer?.matches(DRAWER_SELECTOR)) hydrateDrawer(drawer);
  }, true);

  document.addEventListener('toggle', (event) => {
    const drawer = event.target;
    if (drawer?.matches?.(DRAWER_SELECTOR) && drawer.hasAttribute('open')) {
      hydrateDrawer(drawer);
    }
  });
})();
